import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";
import PricingCards from "@/components/PricingCards";
import Seo from "@/components/Seo";
import api, { redirectToCheckout } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { track } from "@/lib/analytics";

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    api.get("/plans").then(({ data }) => setPlans(data.plans)).catch(() => {});
  }, []);

  const choose = async (key, interval = "monthly") => {
    track("plan_selected", { plan: key, interval });
    if (!user) return navigate(key === "free" ? "/register" : `/register?plan=${key}&interval=${interval}`);
    if (key === "free") return navigate("/app");
    track("checkout_started", { plan: key, interval });
    const { data } = await api.post("/billing/checkout", { plan: key, interval, origin_url: window.location.origin });
    redirectToCheckout(data.url);
  };

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Seo title="Pricing" description="Simple, honest pricing for UK subcontractors. Every feature on every plan — Free (1 project), Growth £29/mo (5 projects), Scale £79/mo (unlimited). Cancel anytime." path="/pricing" />
      <MarketingNav />
      <section className="py-20 flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">Pricing</span>
            <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">One low price. All the tools.</h1>
            <p className="mt-4 text-slate-600">Choose a plan by how many jobs you run at once — every plan includes the full toolset and our fair-use AI takeoff assistant. Archive finished projects to free up space anytime.</p>
          </div>
          <div className="mt-14"><PricingCards plans={plans} onSelect={choose} /></div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Pricing;
